import React, { Component } from "react";
import "./assets/quote.scss";

export default class Quote extends Component {

  constructor() {
    super();
    this.state = {
      quote: []
    };
  }

  async componentDidMount() {
    fetch('http://quotes.rest/qod.json?category=inspire').then(results => {
      return results.json();
    }).then(data => {
      this.setState({quote: data.contents.quotes[0].quote});
    });
  }
  
  render() {
    return (
      <div className="quote container">
        <div className="row">
          <div className="col-8 text-center align-middle">
            <h6>Quote of the day</h6>
            <p>
              <i className="fas fa-quote-left"></i>
              <span>{this.state.quote}</span>
              <i className="fas fa-quote-right"></i>
            </p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/footer/Quote.js